import Axios from "./interceptor";

const API_URL = process.env.REACT_APP_API_BASE_URL + "/api";

const postEmergencyContact = async (data) => {
  const response = await Axios.post(
    API_URL + "/careplanwizarddetail/addemergencycontact",
    data,
  );
  return response;
};

const putEmergencyContact = async (data) => {
  const response = await Axios.put(
    API_URL + "/careplanwizarddetail/editemergencycontact",
    data,
  );
  return response;
};

const putDSDetails = async (data) => {
  const response = await Axios.post(
    `${API_URL}/CarePlanWizardDetail/UpdateCarePlanInformation`,
    data,
  );
  return response.data;
};

const searchEmergencyContacts = async (searchParams) => {
  const response = await Axios.get(
    `${API_URL}/careplanwizarddetail/searchemergencycontacts?${searchParams}`,
  );
  return response;
};

export {
  postEmergencyContact,
  putEmergencyContact,
  putDSDetails,
  searchEmergencyContacts,
};
